/* 
 * NodeMutationBooleanContent.js
 * Created on 28-mrt-2017
 * @author Swen Meeuwes for &ranj
 */

import Content from "./Content";
import ContentFactory from "./ContentFactory";

export default class NodeMutationBooleanContent extends Content {
    constructor(languagePack, contentID, label) {
        super(NodeMutationBooleanContent.NAME, NodeMutationBooleanContent.TYPE, label, languagePack, contentID, true, true);
    }

    remove() {
        this.removeLanguagePackText(NodeMutationBooleanContent.MUTATION_TYPE_LABEL);
        this.removeLanguagePackText(NodeMutationBooleanContent.VALUE_LABEL);
        this.remove();
    }

    clone() {
        clone = new NodeMutationBooleanContent(ContentFactory.getContent(NodeMutationBooleanContent.TYPE, this.getLanguagePack()));
        clone._contentID = this._contentID;
        clone.setMutationType(this.getMutationType());
        clone.setValue(this.getValue());
        return clone;
    }

    getValue() {
        return this.value;
    }

    setValue(value) {
        this.value = value;
    }

    getMutationType() {
        return this.mutationType;
    }

    setMutationType(value) {
        this.mutationType = value;
    }

    convertToObject() {
        return this.getObject(["mutationType", "value"]);
    }
}

NodeMutationBooleanContent.NAME = "Node Mutation (Boolean)";
NodeMutationBooleanContent.TYPE = "engNodeMutationBooleanContent";
NodeMutationBooleanContent.MUTATION_TYPE_LABEL = "mutationType";
NodeMutationBooleanContent.VALUE_LABEL = "value";
